import { faMeta } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Skeleton, Text } from '@feathr/components';

import { formatReachEstimate } from './AdWizardAudienceStep.EstimatedReach.utils';

import * as styles from './AdWizardAudienceStep.css';

interface IMetaReachEstimateProps {
  isLoading: boolean;
  metaReach: number | null;
}

function MetaReachEstimate({
  isLoading,
  metaReach,
}: Readonly<IMetaReachEstimateProps>): JSX.Element {
  const { t } = useTranslation();
  const formattedReach = `${formatReachEstimate(metaReach ?? 0)} ${t('people')}`;

  return (
    <div className={styles.channelReachRow} data-name={'meta-reach-estimate'}>
      <FontAwesomeIcon className={styles.metaIcon} icon={faMeta} />
      <Text.DefaultMedium mantineComponent={'span'}>{t('Est. Meta Ads Reach:')}</Text.DefaultMedium>
      {isLoading ? (
        <Skeleton width={100} />
      ) : (
        <Text.DefaultSemibold mantineComponent={'span'}>{formattedReach}</Text.DefaultSemibold>
      )}
    </div>
  );
}

export default MetaReachEstimate;
